import { useCallback, useContext } from "react"
import { useSelector } from "react-redux";
import { isValid, submit } from "redux-form";
import { SchoolContext } from "../SchoolContext";
import { toastConfig } from "config";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { useMutation } from "@tanstack/react-query";
import { createAffiliationHooks } from "pages/School/CreateAffiliation";
import { app } from "router/routes";
import { useNavigate, useParams } from "react-router-dom";
import { createGradesAndClassesFetch } from "store/middlewares/affiliation.crud";
import { isEmpty } from "lodash";

const useCrudAffiliation = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { affiliationID } = useParams()
    const { affiliationGroup, isSchoolsGroup, formname } = useContext(SchoolContext)
    const formValues = useSelector(state => state.form[formname]?.values)
    const isFormValid = useSelector(state => isValid(formname)(state));
    const createAffiliation = createAffiliationHooks.useCreateAffiliation({
        successMessage: "בית הספר נוצר בהצלחה",
        errorMessage: "ישנה בעייה ביצירת הבית ספר"
    })
    const editAffiliation = createAffiliationHooks.useEditAffiliation({
        successMessage: "בית הספר התעדכן בהצלחה",
        errorMessage: "ישנה בעייה בעדכון הבית ספר"
    })

    const { mutateAsync: createGradesAndClasses } = useMutation({
        mutationFn: createGradesAndClassesFetch
    })

    const getGradesAndClasses = useCallback((grades) => {
        let gradeArray = []
        if (grades) {
            Object.keys(grades).forEach((gradeKey) => {
                if (grades[gradeKey]?.active && grades[gradeKey]?.classes > 0)
                    gradeArray.push({
                        grade: gradeKey,
                        classes: grades[gradeKey]?.classes || 0,
                        name: grades[gradeKey]?.name
                    })
            })
        }
        return gradeArray
    }, [])

    const crudAffiliation = useCallback(async () => {
        if (!isFormValid) {
            toast.error('מלא את כל שדות החובה', toastConfig)
            dispatch(submit(formname))
            return false
        }

        else {
            let func = affiliationID ? editAffiliation : createAffiliation
            const grades = getGradesAndClasses(formValues.grades)

            // אם לא נבחרו שכבות וכיתות והמוסד חדש
            if (isEmpty(grades) && !affiliationID && isSchoolsGroup) {
                toast.error('חובה לבחור לפחות שכבה וכיתה אחת', toastConfig)
                return
            }

            const formData = {
                ...formValues,
                //טיפול בערכים שהגיעו מפולדאון  
                city: formValues.city?.id,
                group: affiliationGroup
            }
            const { data: affiliationId } = await func(formData)
            if (!affiliationID) {

                // במקרה שמיועד ביצירת מוסד מסוג בית ספרי
                if (isSchoolsGroup)
                    await createGradesAndClasses({ id: affiliationId, grades: grades })

                // אנחנו מעבירים את הלקוח לתוך המוסד שזה עתה יצר, כדי שנוכל להעניק לו גישה לשאר הפרטים המחייבים כניסה עם מזהה מוסד
                navigate(`${app.affiliations}/${affiliationId}`)
            }

            return true
        }
    }, [affiliationGroup, isFormValid, formValues, affiliationID, isSchoolsGroup])

    return crudAffiliation
}

export default useCrudAffiliation